module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/037-9e83dcc3af7039c57d4f6212edd8e47d.jpg";